module.exports = __webpack_public_path__ + "img/palm2_8.eb3a8284.png";